import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/home/career/img2.webp";

function HomeCareer() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <section>
      <VisibilitySensor onChange={onChange} partialVisibility minTopValue={300}>
        <div className={`homeCareer ${isVisible ? "visible" : ""}`}>
          <div className="careerTitle">
            <h1 className={`${isVisible ? "visible" : ""}`}>{t("career_home_title")}</h1>
          </div>
          <div className="careerContent">
            <div className="text">
              <p className={`${isVisible ? "visible" : ""}`}>
                {t("career_home_text")}
              </p>
              <a
                className="button"
                href={"https://ghtransporte.vagas.solides.com.br/"}
                target="_blank"
                rel="noreferrer"
                reloadDocument
              >
                <button>{t("career_apply")}</button>
              </a>
            </div>
            <div className="arrows2">
              <img
                className={`img3 ${isVisible ? "visible" : ""}`}
                src={img1}
                alt=""
                width={"200px"}
              />
              <img
                className={`img4 ${isVisible ? "visible" : ""}`}
                src={img1}
                alt=""
                width={"200px"}
              />
            </div>
          </div>
        </div>
      </VisibilitySensor>
    </section>
  );
}

export default HomeCareer;
